// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';
import { Material, type MaterialWireFormat, NewMaterial } from '../Material/Material';

export class MixMaterial {
  readonly material: Material;
  readonly quantity: string | null;
  readonly quantityRatio: string | null;
  readonly quantityUnit: Enums.Unit;
  readonly mixCategory: Enums.MixCategory;
  readonly extendedCost: Currency;
  readonly incompatibleQuantityUnit: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.material = NewMaterial(data.material);
    this.quantity = data.quantity === undefined ? null : data.quantity;
    this.quantityRatio = data.quantityRatio === undefined ? null : data.quantityRatio;
    this.quantityUnit = data.quantityUnit === undefined ? Enums.Unit.CuYd : data.quantityUnit;
    this.mixCategory =
      data.mixCategory === undefined ? Enums.MixCategory.ReadyMix : data.mixCategory;
    this.extendedCost = NewCurrency(data.extendedCost);
    this.incompatibleQuantityUnit =
      (data.incompatibleBatchUnit ?? data.incompatibleQuantityUnit) === undefined
        ? false
        : (data.incompatibleBatchUnit ?? data.incompatibleQuantityUnit);
  }

  static zero(): MixMaterial {
    const zeroValues: ExcludeMethodsDeep<MixMaterial> = {
      material: Material.zero(),
      quantity: null,
      quantityRatio: null,
      quantityUnit: Enums.Unit.CuYd,
      mixCategory: Enums.MixCategory.ReadyMix,
      extendedCost: Currency.zero(),
      incompatibleQuantityUnit: false,
    };
    return new MixMaterial(zeroValues);
  }

  toJSON(): { [key: string]: any } {
    return {
      material: this.material,
      quantity: this.quantity,
      quantityRatio: this.quantityRatio,
      quantityUnit: this.quantityUnit,
      mixCategory: this.mixCategory,
      extendedCost: this.extendedCost,
      incompatibleBatchUnit: this.incompatibleQuantityUnit,
    };
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MixMaterialWireFormat = {
  material: MaterialWireFormat;
  quantity: string | null;
  quantityRatio: string | null;
  quantityUnit: string;
  mixCategory: string;
  extendedCost: CurrencyWireFormat;
  incompatibleQuantityUnit: boolean;
};

type NewMixMaterialProps = PartialDeep<MixMaterial, { recurseIntoArrays: true }>;
export const NewMixMaterial: (props: NewMixMaterialProps) => MixMaterial = (props) =>
  new MixMaterial(props);

type NewMixMaterialFromWireFormatProps = PartialDeep<
  MixMaterialWireFormat,
  { recurseIntoArrays: true }
>;
export const NewMixMaterialFromWireFormat: (
  props: NewMixMaterialFromWireFormatProps,
) => MixMaterial = (props) => new MixMaterial(props);
